require('./bootstrap');
import store from './store.js';

window.Vue = require('vue');
window.Vuex = require('vuex');
Vue.use(Vuex);

import ElementUI from 'element-ui';
import '~/../sass/element_variables.scss';
import locale from 'element-ui/lib/locale/lang/es';
Vue.use(ElementUI, { locale });

import Notify from 'vue-notifyjs';
Vue.use(Notify, { type: 'danger', timeout: 2000 });

Vue.component('products-list', require('./components/ProductsList.vue').default);
Vue.component('cart-dropdown', require('./components/Cart.vue').default);
Vue.component('date-component', require('./components/DateComponent.vue').default);
Vue.component('month-component', require('./components/MonthComponent.vue').default);
Vue.component(
  'date-range-component',
  require('./components/DateRangeComponent.vue').default
);
Vue.component(
  'file-upload-component',
  require('./components/FileUploadComponent.vue').default
);
Vue.component('doc-upload', require('./components/DocUpload.vue').default);



const app = new Vue({
    el: '#app',

    store: new Vuex.Store(store)
});
